import { jsx as _jsx } from "react/jsx-runtime";
import { OfferCardContext } from '@/contexts/offerCard.context';
export function OfferCardProvider({ offerCard, children }) {
    return (_jsx(OfferCardContext.Provider, { value: offerCard, children: children }));
}
